import _asyncToGenerator from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _assertThisInitialized from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _possibleConstructorReturn from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _wrapNativeSuper from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/home/runner/work/website/website/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.sort.js";
var Vt = {},
  ge = function ge(t, e, r, a, n) {
    var i = new Worker(Vt[e] || (Vt[e] = URL.createObjectURL(new Blob([t + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'], {
      type: "text/javascript"
    }))));
    return i.onmessage = function (s) {
      var u = s.data,
        l = u.$e$;
      if (l) {
        var o = new Error(l[0]);
        o.code = l[1], o.stack = l[2], n(o, null);
      } else n(null, u);
    }, i.postMessage(r, a), i;
  },
  O = Uint8Array,
  H = Uint16Array,
  Ct = Int32Array,
  At = new O([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0]),
  bt = new O([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0]),
  qt = new O([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]),
  Rt = function Rt(t, e) {
    for (var r = new H(31), a = 0; a < 31; ++a) r[a] = e += 1 << t[a - 1];
    for (var n = new Ct(r[30]), a = 1; a < 30; ++a) for (var i = r[a]; i < r[a + 1]; ++i) n[i] = i - r[a] << 5 | a;
    return {
      b: r,
      r: n
    };
  },
  $t = Rt(At, 2),
  It = $t.b,
  _e = $t.r;
It[28] = 258, _e[258] = 28;
var Jt = Rt(bt, 0),
  Ht = Jt.b,
  ut = new H(32768);
for (_ = 0; _ < 32768; ++_) R = (_ & 43690) >> 1 | (_ & 21845) << 1, R = (R & 52428) >> 2 | (R & 13107) << 2, R = (R & 61680) >> 4 | (R & 3855) << 4, ut[_] = ((R & 65280) >> 8 | (R & 255) << 8) >> 1;
var R,
  _,
  K = function K(t, e, r) {
    for (var a = t.length, n = 0, i = new H(e); n < a; ++n) t[n] && ++i[t[n] - 1];
    var s = new H(e);
    for (n = 1; n < e; ++n) s[n] = s[n - 1] + i[n - 1] << 1;
    var u;
    if (r) {
      u = new H(1 << e);
      var l = 15 - e;
      for (n = 0; n < a; ++n) if (t[n]) for (var o = n << 4 | t[n], c = e - t[n], f = s[t[n] - 1]++ << c, h = f | (1 << c) - 1; f <= h; ++f) u[ut[f] >> l] = o;
    } else for (u = new H(a), n = 0; n < a; ++n) t[n] && (u[n] = ut[s[t[n] - 1]++] >> 15 - t[n]);
    return u;
  },
  tt = new O(288);
for (_ = 0; _ < 144; ++_) tt[_] = 8;
var _;
for (_ = 144; _ < 256; ++_) tt[_] = 9;
var _;
for (_ = 256; _ < 280; ++_) tt[_] = 7;
var _;
for (_ = 280; _ < 288; ++_) tt[_] = 8;
var _,
  Wt = new O(32);
for (_ = 0; _ < 32; ++_) Wt[_] = 5;
var _;
var Gt = K(tt, 9, 1);
var Zt = K(Wt, 5, 1),
  st = function st(t) {
    for (var e = t[0], r = 1; r < t.length; ++r) t[r] > e && (e = t[r]);
    return e;
  },
  N = function N(t, e, r) {
    var a = e / 8 | 0;
    return (t[a] | t[a + 1] << 8) >> (e & 7) & r;
  },
  ot = function ot(t, e) {
    var r = e / 8 | 0;
    return (t[r] | t[r + 1] << 8 | t[r + 2] << 16) >> (e & 7);
  },
  Kt = function Kt(t) {
    return (t + 7) / 8 | 0;
  },
  lt = function lt(t, e, r) {
    return (e == null || e < 0) && (e = 0), (r == null || r > t.length) && (r = t.length), new O(t.subarray(e, r));
  };
var Yt = ["unexpected EOF", "invalid block type", "invalid length/literal", "invalid distance", "stream finished", "no stream handler",, "no callback", "invalid UTF-8 data", "extra field too long", "date not in range 1980-2099", "filename too long", "stream finishing", "invalid zip data"],
  E = function E(t, e, r) {
    var a = new Error(e || Yt[t]);
    if (a.code = t, Error.captureStackTrace && Error.captureStackTrace(a, E), !r) throw a;
    return a;
  },
  Xt = function Xt(t, e, r, a) {
    var n = t.length,
      i = a ? a.length : 0;
    if (!n || e.f && !e.l) return r || new O(0);
    var s = !r,
      u = s || e.i != 2,
      l = e.i;
    s && (r = new O(n * 3));
    var o = function o(Ut) {
        var Ft = r.length;
        if (Ut > Ft) {
          var Bt = new O(Math.max(Ft * 2, Ut));
          Bt.set(r), r = Bt;
        }
      },
      c = e.f || 0,
      f = e.p || 0,
      h = e.b || 0,
      p = e.l,
      m = e.d,
      d = e.m,
      y = e.n,
      v = n * 8;
    do {
      if (!p) {
        c = N(t, f, 1);
        var A = N(t, f + 1, 3);
        if (f += 3, A) {
          if (A == 1) p = Gt, m = Zt, d = 9, y = 5;else if (A == 2) {
            var C = N(t, f, 31) + 257,
              D = N(t, f + 10, 15) + 4,
              V = C + N(t, f + 5, 31) + 1;
            f += 14;
            for (var x = new O(V), q = new O(19), b = 0; b < D; ++b) q[qt[b]] = N(t, f + b * 3, 7);
            f += D * 3;
            for (var L = st(q), mt = (1 << L) - 1, nt = K(q, L, 1), b = 0; b < V;) {
              var U = nt[N(t, f, mt)];
              f += U & 15;
              var g = U >> 4;
              if (g < 16) x[b++] = g;else {
                var T = 0,
                  at = 0;
                for (g == 16 ? (at = 3 + N(t, f, 3), f += 2, T = x[b - 1]) : g == 17 ? (at = 3 + N(t, f, 7), f += 3) : g == 18 && (at = 11 + N(t, f, 127), f += 7); at--;) x[b++] = T;
              }
            }
            var Tt = x.subarray(0, C),
              $ = x.subarray(C);
            d = st(Tt), y = st($), p = K(Tt, d, 1), m = K($, y, 1);
          } else E(1);
        } else {
          var g = Kt(f) + 4,
            M = t[g - 4] | t[g - 3] << 8,
            S = g + M;
          if (S > n) {
            l && E(0);
            break;
          }
          u && o(h + M), r.set(t.subarray(g, S), h), e.b = h += M, e.p = f = S * 8, e.f = c;
          continue;
        }
        if (f > v) {
          l && E(0);
          break;
        }
      }
      u && o(h + 131072);
      for (var me = (1 << d) - 1, ve = (1 << y) - 1, vt = f;; vt = f) {
        var T = p[ot(t, f) & me],
          Z = T >> 4;
        if (f += T & 15, f > v) {
          l && E(0);
          break;
        }
        if (T || E(2), Z < 256) r[h++] = Z;else if (Z == 256) {
          vt = f, p = null;
          break;
        } else {
          var Nt = Z - 254;
          if (Z > 264) {
            var b = Z - 257,
              Q = At[b];
            Nt = N(t, f, (1 << Q) - 1) + It[b], f += Q;
          }
          var yt = m[ot(t, f) & ve],
            gt = yt >> 4;
          yt || E(3), f += yt & 15;
          var $ = Ht[gt];
          if (gt > 3) {
            var Q = bt[gt];
            $ += ot(t, f) & (1 << Q) - 1, f += Q;
          }
          if (f > v) {
            l && E(0);
            break;
          }
          u && o(h + 131072);
          var jt = h + Nt;
          if (h < $) {
            var Lt = i - $,
              ye = Math.min($, jt);
            for (Lt + h < 0 && E(3); h < ye; ++h) r[h] = a[Lt + h];
          }
          for (; h < jt; ++h) r[h] = r[h - $];
        }
      }
      e.l = p, e.p = vt, e.b = h, e.f = c, p && (c = 1, e.m = d, e.d = m, e.n = y);
    } while (!c);
    return h != r.length && s ? lt(r, 0, h) : r.subarray(0, h);
  };
var we = new O(0);
var Ae = function Ae(t, e) {
    var r = {};
    for (var a in t) r[a] = t[a];
    for (var a in e) r[a] = e[a];
    return r;
  },
  Pt = function Pt(t, e, r) {
    for (var a = t(), n = t.toString(), i = n.slice(n.indexOf("[") + 1, n.lastIndexOf("]")).replace(/\s+/g, "").split(","), s = 0; s < a.length; ++s) {
      var u = a[s],
        l = i[s];
      if (typeof u == "function") {
        e += ";" + l + "=";
        var o = u.toString();
        if (u.prototype) {
          if (o.indexOf("[native code]") != -1) {
            var c = o.indexOf(" ", 8) + 1;
            e += o.slice(c, o.indexOf("(", c));
          } else {
            e += o;
            for (var f in u.prototype) e += ";" + l + ".prototype." + f + "=" + u.prototype[f].toString();
          }
        } else e += o;
      } else r[l] = u;
    }
    return e;
  },
  it = [],
  be = function be(t) {
    var e = [];
    for (var r in t) t[r].buffer && e.push((t[r] = new t[r].constructor(t[r])).buffer);
    return e;
  },
  Ie = function Ie(t, e, r, a) {
    if (!it[r]) {
      for (var n = "", i = {}, s = t.length - 1, u = 0; u < s; ++u) n = Pt(t[u], n, i);
      it[r] = {
        c: Pt(t[s], n, i),
        e: i
      };
    }
    var l = Ae({}, it[r].e);
    return ge(it[r].c + ";onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=" + e.toString() + "}", r, l, be(l), a);
  },
  xe = function xe() {
    return [O, H, Ct, At, bt, qt, It, Ht, Gt, Zt, ut, Yt, K, st, N, ot, Kt, lt, E, Xt, xt, Qt, te];
  };
var Qt = function Qt(t) {
    return postMessage(t, [t.buffer]);
  },
  te = function te(t) {
    return t && {
      out: t.size && new O(t.size),
      dictionary: t.dictionary
    };
  },
  Ee = function Ee(t, e, r, a, n, i) {
    var s = Ie(r, a, n, function (u, l) {
      s.terminate(), i(u, l);
    });
    return s.postMessage([t, e], e.consume ? [t.buffer] : []), function () {
      s.terminate();
    };
  };
var P = function P(t, e) {
    return t[e] | t[e + 1] << 8;
  },
  F = function F(t, e) {
    return (t[e] | t[e + 1] << 8 | t[e + 2] << 16 | t[e + 3] << 24) >>> 0;
  },
  _t = function _t(t, e) {
    return F(t, e) + F(t, e + 4) * 4294967296;
  };
function Oe(t, e, r) {
  return r || (r = e, e = {}), typeof r != "function" && E(7), Ee(t, e, [xe], function (a) {
    return Qt(xt(a.data[0], te(a.data[1])));
  }, 1, r);
}
function xt(t, e) {
  return Xt(t, {
    i: 2
  }, e && e.out, e && e.dictionary);
}
var wt = typeof TextDecoder < "u" && new TextDecoder(),
  ze = 0;
try {
  wt.decode(we, {
    stream: !0
  }), ze = 1;
} catch (_unused) {}
var Se = function Se(t) {
  for (var e = "", r = 0;;) {
    var a = t[r++],
      n = (a > 127) + (a > 223) + (a > 239);
    if (r + n > t.length) return {
      s: e,
      r: lt(t, r - 1)
    };
    n ? n == 3 ? (a = ((a & 15) << 18 | (t[r++] & 63) << 12 | (t[r++] & 63) << 6 | t[r++] & 63) - 65536, e += String.fromCharCode(55296 | a >> 10, 56320 | a & 1023)) : n & 1 ? e += String.fromCharCode((a & 31) << 6 | t[r++] & 63) : e += String.fromCharCode((a & 15) << 12 | (t[r++] & 63) << 6 | t[r++] & 63) : e += String.fromCharCode(a);
  }
};
function W(t, e) {
  if (e) {
    for (var r = "", a = 0; a < t.length; a += 16384) r += String.fromCharCode.apply(null, t.subarray(a, a + 16384));
    return r;
  } else {
    if (wt) return wt.decode(t);
    var n = Se(t),
      i = n.s,
      r = n.r;
    return r.length && E(8), i;
  }
}
var Me = function Me(t, e) {
    return e + 30 + P(t, e + 26) + P(t, e + 28);
  },
  De = function De(t, e, r) {
    var a = P(t, e + 28),
      n = W(t.subarray(e + 46, e + 46 + a), !(P(t, e + 8) & 2048)),
      i = e + 46 + a,
      s = F(t, e + 20),
      u = r && s == 4294967295 ? Te(t, i) : [s, F(t, e + 24), F(t, e + 42)],
      l = u[0],
      o = u[1],
      c = u[2];
    return [P(t, e + 10), l, o, n, i + P(t, e + 30) + P(t, e + 32), c];
  },
  Te = function Te(t, e) {
    for (; P(t, e) != 1; e += 4 + P(t, e + 2));
    return [_t(t, e + 12), _t(t, e + 4), _t(t, e + 20)];
  };
var kt = typeof queueMicrotask == "function" ? queueMicrotask : typeof setTimeout == "function" ? setTimeout : function (t) {
  t();
};
function ee(t, e, r) {
  r || (r = e, e = {}), typeof r != "function" && E(7);
  var a = [],
    n = function n() {
      for (var y = 0; y < a.length; ++y) a[y]();
    },
    i = {},
    s = function s(y, v) {
      kt(function () {
        r(y, v);
      });
    };
  kt(function () {
    s = r;
  });
  for (var u = t.length - 22; F(t, u) != 101010256; --u) if (!u || t.length - u > 65558) return s(E(13, 0, 1), null), n;
  var l = P(t, u + 8);
  if (l) {
    var o = l,
      c = F(t, u + 16),
      f = c == 4294967295 || o == 65535;
    if (f) {
      var h = F(t, u - 12);
      f = F(t, h) == 101075792, f && (o = l = F(t, h + 32), c = F(t, h + 48));
    }
    for (var p = e && e.filter, m = function m(y) {
        var v = De(t, c, f),
          A = v[0],
          g = v[1],
          M = v[2],
          S = v[3],
          C = v[4],
          D = v[5],
          V = Me(t, D);
        c = C;
        var x = function x(b, L) {
          b ? (n(), s(b, null)) : (L && (i[S] = L), --l || s(null, i));
        };
        if (!p || p({
          name: S,
          size: g,
          originalSize: M,
          compression: A
        })) {
          if (!A) x(null, lt(t, V, V + g));else if (A == 8) {
            var q = t.subarray(V, V + g);
            if (g < 32e4) try {
              x(null, xt(q, {
                out: new O(M)
              }));
            } catch (b) {
              x(b, null);
            } else a.push(Oe(q, {
              size: M
            }, x));
          } else x(E(14, "unknown compression type " + A, 1), null);
        } else x(null, null);
      }, d = 0; d < o; ++d) m(d);
  } else s(null, {});
  return n;
}
function re(t) {
  return (Array.isArray(t) ? t : t.issues).reduce(function (e, r) {
    if (r.path) {
      var a = r.path.map(function (_ref) {
        var n = _ref.key;
        return n;
      }).join(".");
      e.nested[a] = [].concat(_toConsumableArray(e.nested[a] || []), [r.message]);
    } else e.root = [].concat(_toConsumableArray(e.root || []), [r.message]);
    return e;
  }, {
    nested: {}
  });
}
var Ne = /*#__PURE__*/function (_Error) {
  function Ne(t) {
    var _this;
    _classCallCheck(this, Ne);
    (_this = _callSuper(this, Ne, [t[0].message]), _defineProperty(_assertThisInitialized(_this), "issues", void 0)), _this.name = "ValiError", _this.issues = t;
    return _this;
  }
  _inherits(Ne, _Error);
  return _createClass(Ne);
}( /*#__PURE__*/_wrapNativeSuper(Error));
function je(t, e) {
  return {
    reason: t == null ? void 0 : t.reason,
    validation: e.validation,
    origin: (t == null ? void 0 : t.origin) || "value",
    message: e.message,
    input: e.input,
    abortEarly: t == null ? void 0 : t.abortEarly,
    abortPipeEarly: t == null ? void 0 : t.abortPipeEarly
  };
}
function Le(t, e) {
  return {
    reason: e,
    origin: t == null ? void 0 : t.origin,
    abortEarly: t == null ? void 0 : t.abortEarly,
    abortPipeEarly: t == null ? void 0 : t.abortPipeEarly
  };
}
function J(t, e, r, a) {
  if (!e || !e.length) return {
    output: t
  };
  var n,
    i,
    s = t;
  var _iterator = _createForOfIteratorHelper(e),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var u = _step.value;
      var l = u(s);
      if (l.issue) {
        n = n || Le(r, a);
        var o = je(n, l.issue);
        if (i ? i.push(o) : i = [o], n.abortEarly || n.abortPipeEarly) break;
      } else s = l.output;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return i ? {
    issues: i
  } : {
    output: s
  };
}
function B(t, e) {
  return !t || typeof t == "string" ? [t, e] : [void 0, t];
}
function k(t, e, r, a, n, i) {
  return {
    issues: [{
      reason: e,
      validation: r,
      origin: (t == null ? void 0 : t.origin) || "value",
      message: a,
      input: n,
      issues: i,
      abortEarly: t == null ? void 0 : t.abortEarly,
      abortPipeEarly: t == null ? void 0 : t.abortPipeEarly
    }]
  };
}
function ne() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return {
    schema: "any",
    async: !1,
    _parse: function _parse(e, r) {
      return J(e, t, r, "any");
    }
  };
}
function Y(t, e, r) {
  var _B = B(e, r),
    _B2 = _slicedToArray(_B, 2),
    a = _B2[0],
    n = _B2[1];
  return {
    schema: "array",
    array: {
      item: t
    },
    async: !1,
    _parse: function _parse(i, s) {
      if (!Array.isArray(i)) return k(s, "type", "array", a || "Invalid type", i);
      var u,
        l = [];
      for (var o = 0; o < i.length; o++) {
        var c = i[o],
          f = t._parse(c, s);
        if (f.issues) {
          var h = {
            schema: "array",
            input: i,
            key: o,
            value: c
          };
          var _iterator2 = _createForOfIteratorHelper(f.issues),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var p = _step2.value;
              p.path ? p.path.unshift(h) : p.path = [h], u == null || u.push(p);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          if (u || (u = f.issues), s != null && s.abortEarly) break;
        } else l.push(f.output);
      }
      return u ? {
        issues: u
      } : J(l, n, s, "array");
    }
  };
}
function ct(t, e) {
  var _B3 = B(t, e),
    _B4 = _slicedToArray(_B3, 2),
    r = _B4[0],
    a = _B4[1];
  return {
    schema: "boolean",
    async: !1,
    _parse: function _parse(n, i) {
      return typeof n != "boolean" ? k(i, "type", "boolean", r || "Invalid type", n) : J(n, a, i, "boolean");
    }
  };
}
function Et(t, e) {
  return {
    schema: "literal",
    literal: t,
    async: !1,
    _parse: function _parse(r, a) {
      return r !== t ? k(a, "type", "literal", e || "Invalid type", r) : {
        output: r
      };
    }
  };
}
function ae(t, e) {
  return {
    schema: "native_enum",
    nativeEnum: t,
    async: !1,
    _parse: function _parse(r, a) {
      return Object.values(t).includes(r) ? {
        output: r
      } : k(a, "type", "native_enum", e || "Invalid type", r);
    }
  };
}
function j(t, e) {
  var _B5 = B(t, e),
    _B6 = _slicedToArray(_B5, 2),
    r = _B6[0],
    a = _B6[1];
  return {
    schema: "number",
    async: !1,
    _parse: function _parse(n, i) {
      return typeof n != "number" ? k(i, "type", "number", r || "Invalid type", n) : J(n, a, i, "number");
    }
  };
}
function z(t, e, r) {
  var _B7 = B(e, r),
    _B8 = _slicedToArray(_B7, 2),
    a = _B8[0],
    n = _B8[1],
    i;
  return {
    schema: "object",
    object: t,
    async: !1,
    _parse: function _parse(s, u) {
      if (!s || typeof s != "object") return k(u, "type", "object", a || "Invalid type", s);
      i = i || Object.entries(t);
      var l,
        o = {};
      var _iterator3 = _createForOfIteratorHelper(i),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = _slicedToArray(_step3.value, 2),
            c = _step3$value[0],
            f = _step3$value[1];
          var h = s[c],
            p = f._parse(h, u);
          if (p.issues) {
            var m = {
              schema: "object",
              input: s,
              key: c,
              value: h
            };
            var _iterator4 = _createForOfIteratorHelper(p.issues),
              _step4;
            try {
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                var d = _step4.value;
                d.path ? d.path.unshift(m) : d.path = [m], l == null || l.push(d);
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }
            if (l || (l = p.issues), u != null && u.abortEarly) break;
          } else o[c] = p.output;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return l ? {
        issues: l
      } : J(o, n, u, "object");
    }
  };
}
function w(t) {
  return {
    schema: "optional",
    wrapped: t,
    async: !1,
    _parse: function _parse(e, r) {
      return e === void 0 ? {
        output: e
      } : t._parse(e, r);
    }
  };
}
function I(t, e) {
  var _B9 = B(t, e),
    _B10 = _slicedToArray(_B9, 2),
    r = _B10[0],
    a = _B10[1];
  return {
    schema: "string",
    async: !1,
    _parse: function _parse(n, i) {
      return typeof n != "string" ? k(i, "type", "string", r || "Invalid type", n) : J(n, a, i, "string");
    }
  };
}
function Ue(t, e, r, a) {
  if (typeof e == "object" && !Array.isArray(e)) {
    var _B11 = B(r, a),
      _B12 = _slicedToArray(_B11, 2),
      s = _B12[0],
      u = _B12[1];
    return [t, e, s, u];
  }
  var _B13 = B(e, r),
    _B14 = _slicedToArray(_B13, 2),
    n = _B14[0],
    i = _B14[1];
  return [I(), t, n, i];
}
var Fe = ["__proto__", "prototype", "constructor"];
function Ot(t, e, r, a) {
  var _Ue = Ue(t, e, r, a),
    _Ue2 = _slicedToArray(_Ue, 4),
    n = _Ue2[0],
    i = _Ue2[1],
    s = _Ue2[2],
    u = _Ue2[3];
  return {
    schema: "record",
    record: {
      key: n,
      value: i
    },
    async: !1,
    _parse: function _parse(l, o) {
      if (!l || typeof l != "object") return k(o, "type", "record", s || "Invalid type", l);
      var c,
        f = {};
      for (var _i = 0, _Object$entries = Object.entries(l); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          h = _Object$entries$_i[0],
          p = _Object$entries$_i[1];
        if (!Fe.includes(h)) {
          var m = void 0,
            d = n._parse(h, {
              origin: "key",
              abortEarly: o == null ? void 0 : o.abortEarly,
              abortPipeEarly: o == null ? void 0 : o.abortPipeEarly
            });
          if (d.issues) {
            m = {
              schema: "record",
              input: l,
              key: h,
              value: p
            };
            var _iterator5 = _createForOfIteratorHelper(d.issues),
              _step5;
            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var v = _step5.value;
                v.path = [m], c == null || c.push(v);
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }
            if (c || (c = d.issues), o != null && o.abortEarly) break;
          }
          var y = i._parse(p, o);
          if (y.issues) {
            m = m || {
              schema: "record",
              input: l,
              key: h,
              value: p
            };
            var _iterator6 = _createForOfIteratorHelper(y.issues),
              _step6;
            try {
              for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                var _v = _step6.value;
                _v.path ? _v.path.unshift(m) : _v.path = [m], c == null || c.push(_v);
              }
            } catch (err) {
              _iterator6.e(err);
            } finally {
              _iterator6.f();
            }
            if (c || (c = y.issues), o != null && o.abortEarly) break;
          }
          !d.issues && !y.issues && (f[d.output] = y.output);
        }
      }
      return c ? {
        issues: c
      } : J(f, u, o, "record");
    }
  };
}
function Be(t, e, r) {
  if (typeof t == "object" && !Array.isArray(t)) {
    var _B15 = B(e, r),
      _B16 = _slicedToArray(_B15, 2),
      i = _B16[0],
      s = _B16[1];
    return [t, i, s];
  }
  var _B17 = B(t, e),
    _B18 = _slicedToArray(_B17, 2),
    a = _B18[0],
    n = _B18[1];
  return [void 0, a, n];
}
function zt(t, e, r, a) {
  var _Be = Be(e, r, a),
    _Be2 = _slicedToArray(_Be, 3),
    n = _Be2[0],
    i = _Be2[1],
    s = _Be2[2];
  return {
    schema: "tuple",
    tuple: {
      items: t,
      rest: n
    },
    async: !1,
    _parse: function _parse(u, l) {
      if (!Array.isArray(u) || !n && t.length !== u.length || n && t.length > u.length) return k(l, "type", "tuple", i || "Invalid type", u);
      var o,
        c = [];
      for (var f = 0; f < t.length; f++) {
        var h = u[f],
          p = t[f]._parse(h, l);
        if (p.issues) {
          var m = {
            schema: "tuple",
            input: u,
            key: f,
            value: h
          };
          var _iterator7 = _createForOfIteratorHelper(p.issues),
            _step7;
          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              var d = _step7.value;
              d.path ? d.path.unshift(m) : d.path = [m], o == null || o.push(d);
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }
          if (o || (o = p.issues), l != null && l.abortEarly) break;
        } else c[f] = p.output;
      }
      if (n) for (var _f = t.length; _f < u.length; _f++) {
        var _h = u[_f],
          _p = n._parse(_h, l);
        if (_p.issues) {
          var _m = {
            schema: "tuple",
            input: u,
            key: _f,
            value: _h
          };
          var _iterator8 = _createForOfIteratorHelper(_p.issues),
            _step8;
          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var _d = _step8.value;
              _d.path ? _d.path.unshift(_m) : _d.path = [_m], o == null || o.push(_d);
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }
          if (o || (o = _p.issues), l != null && l.abortEarly) break;
        } else c[_f] = _p.output;
      }
      return o ? {
        issues: o
      } : J(c, s, l, "tuple");
    }
  };
}
function ft(t, e) {
  return {
    schema: "union",
    union: t,
    async: !1,
    _parse: function _parse(r, a) {
      var n, i;
      var _iterator9 = _createForOfIteratorHelper(t),
        _step9;
      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var s = _step9.value;
          var u = s._parse(r, a);
          if (u.issues) {
            if (n) {
              var _iterator10 = _createForOfIteratorHelper(u.issues),
                _step10;
              try {
                for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                  var l = _step10.value;
                  n.push(l);
                }
              } catch (err) {
                _iterator10.e(err);
              } finally {
                _iterator10.f();
              }
            } else n = u.issues;
          } else {
            i = [u.output];
            break;
          }
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
      return i ? {
        output: i[0]
      } : k(a, "type", "union", e || "Invalid type", r, n);
    }
  };
}
function X(t, e, r) {
  var _B19 = B(e, r),
    _B20 = _slicedToArray(_B19, 2),
    a = _B20[0],
    n = _B20[1];
  return z(t.reduce(function (i, s) {
    return _objectSpread(_objectSpread({}, i), s.object);
  }, {}), a, n);
}
function ie(t, e, r, a) {
  var _B21 = B(r, a),
    _B22 = _slicedToArray(_B21, 2),
    n = _B22[0],
    i = _B22[1];
  return z(Object.entries(t.object).reduce(function (s, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      u = _ref3[0],
      l = _ref3[1];
    return e.includes(u) ? s : _objectSpread(_objectSpread({}, s), {}, _defineProperty({}, u, l));
  }, {}), n, i);
}
function se(t, e, r) {
  var a = t._parse(e, r);
  return a.issues ? {
    success: !1,
    error: new Ne(a.issues),
    issues: a.issues
  } : {
    success: !0,
    data: a.output,
    output: a.output
  };
}
function ht(t, e) {
  return function (r) {
    return r > t ? {
      issue: {
        validation: "max_value",
        message: e || "Invalid value",
        input: r
      }
    } : {
      output: r
    };
  };
}
function dt(t, e) {
  return function (r) {
    return r < t ? {
      issue: {
        validation: "min_value",
        message: e || "Invalid value",
        input: r
      }
    } : {
      output: r
    };
  };
}
var Ve = Object.create,
  St = Object.defineProperty,
  Pe = Object.getOwnPropertyDescriptor,
  fe = Object.getOwnPropertyNames,
  ke = Object.getPrototypeOf,
  Ce = Object.prototype.hasOwnProperty,
  qe = function qe(t, e, r) {
    return e in t ? St(t, e, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: r
    }) : t[e] = r;
  },
  et = function et(t, e) {
    return function () {
      return e || (0, t[fe(t)[0]])((e = {
        exports: {}
      }).exports, e), e.exports;
    };
  },
  Re = function Re(t, e, r, a) {
    if (e && typeof e == "object" || typeof e == "function") {
      var _iterator11 = _createForOfIteratorHelper(fe(e)),
        _step11;
      try {
        var _loop = function _loop() {
          var n = _step11.value;
          !Ce.call(t, n) && n !== r && St(t, n, {
            get: function get() {
              return e[n];
            },
            enumerable: !(a = Pe(e, n)) || a.enumerable
          });
        };
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
    }
    return t;
  },
  $e = function $e(t, e, r) {
    return r = t != null ? Ve(ke(t)) : {}, Re(e || !t || !t.__esModule ? St(r, "default", {
      value: t,
      enumerable: !0
    }) : r, t);
  },
  Je = function Je(t, e, r) {
    return qe(t, typeof e != "symbol" ? e + "" : e, r), r;
  },
  He = et({
    "../../node_modules/.pnpm/@rgba-image+copy@0.1.3/node_modules/@rgba-image/copy/dist/index.js": function node_modulesPnpmRgbaImageCopy013Node_modulesRgbaImageCopyDistIndexJs(t) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.copy = void 0;
      var e = function e(r, a) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : r.width - n;
        var u = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : r.height - i;
        var l = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
        var o = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
        if (n = n | 0, i = i | 0, s = s | 0, u = u | 0, l = l | 0, o = o | 0, s <= 0 || u <= 0) return;
        var c = new Uint32Array(r.data.buffer),
          f = new Uint32Array(a.data.buffer);
        for (var h = 0; h < u; h++) {
          var p = i + h;
          if (p < 0 || p >= r.height) continue;
          var m = o + h;
          if (!(m < 0 || m >= a.height)) for (var d = 0; d < s; d++) {
            var y = n + d;
            if (y < 0 || y >= r.width) continue;
            var v = l + d;
            if (v < 0 || v >= a.width) continue;
            var A = p * r.width + y,
              g = m * a.width + v;
            f[g] = c[A];
          }
        }
      };
      t.copy = e;
    }
  }),
  We = et({
    "../../node_modules/.pnpm/@rgba-image+create-image@0.1.1/node_modules/@rgba-image/create-image/dist/index.js": function node_modulesPnpmRgbaImageCreateImage011Node_modulesRgbaImageCreateImageDistIndexJs(t) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.CreateImageFactory = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [0, 0, 0, 0];
        var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
        if (r = Math.floor(r), isNaN(r) || r < 1) throw TypeError("channels should be a positive non-zero number");
        if (!("length" in e) || e.length < r) throw TypeError("fill should be iterable with at least ".concat(r, " members"));
        e = new Uint8ClampedArray(e).slice(0, r);
        var a = e.every(function (i) {
          return i === 0;
        });
        return function (i, s, u) {
          if (i === void 0 || s === void 0) throw TypeError("Not enough arguments");
          if (i = Math.floor(i), s = Math.floor(s), isNaN(i) || i < 1 || isNaN(s) || s < 1) throw TypeError("Index or size is negative or greater than the allowed amount");
          var l = i * s * r;
          if (u === void 0 && (u = new Uint8ClampedArray(l)), u instanceof Uint8ClampedArray) {
            if (u.length !== l) throw TypeError("Index or size is negative or greater than the allowed amount");
            if (!a) for (var o = 0; o < s; o++) for (var c = 0; c < i; c++) {
              var f = (o * i + c) * r;
              for (var h = 0; h < r; h++) u[f + h] = e[h];
            }
            return {
              get width() {
                return i;
              },
              get height() {
                return s;
              },
              get data() {
                return u;
              }
            };
          }
          throw TypeError("Expected data to be Uint8ClampedArray or undefined");
        };
      }, t.createImage = t.CreateImageFactory();
    }
  }),
  Ge = et({
    "../../node_modules/.pnpm/@rgba-image+lanczos@0.1.1/node_modules/@rgba-image/lanczos/dist/filters.js": function node_modulesPnpmRgbaImageLanczos011Node_modulesRgbaImageLanczosDistFiltersJs(t) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.filters = void 0;
      var e = 14,
        r = function r(i, s) {
          if (i <= -s || i >= s || i == 0) return 0;
          var u = i * Math.PI;
          return Math.sin(u) / u * Math.sin(u / s) / (u / s);
        },
        a = function a(i) {
          return Math.round(i * ((1 << e) - 1));
        },
        n = function n(i, s, u, l, o) {
          var c = o ? 2 : 3,
            f = 1 / u,
            h = Math.min(1, u),
            p = c / h,
            m = Math.floor((p + 1) * 2),
            d = new Int16Array((m + 2) * s),
            y = 0;
          for (var v = 0; v < s; v++) {
            var A = (v + .5) * f + l,
              g = Math.max(0, Math.floor(A - p)),
              M = Math.min(i - 1, Math.ceil(A + p)),
              S = M - g + 1,
              C = new Float32Array(S),
              D = new Int16Array(S),
              V = 0,
              x = 0;
            for (var U = g; U <= M; U++) {
              var T = r((U + .5 - A) * h, c);
              V += T, C[x] = T, x++;
            }
            var q = 0;
            for (var _U = 0; _U < C.length; _U++) {
              var _T = C[_U] / V;
              q += _T, D[_U] = a(_T);
            }
            D[s >> 1] += a(1 - q);
            var b = 0;
            for (; b < D.length && D[b] === 0;) b++;
            var L = D.length - 1;
            for (; L > 0 && D[L] === 0;) L--;
            var mt = g + b,
              nt = L - b + 1;
            d[y++] = mt, d[y++] = nt, d.set(D.subarray(b, L + 1), y), y += nt;
          }
          return d;
        };
      t.filters = n;
    }
  }),
  Ze = et({
    "../../node_modules/.pnpm/@rgba-image+lanczos@0.1.1/node_modules/@rgba-image/lanczos/dist/convolve.js": function node_modulesPnpmRgbaImageLanczos011Node_modulesRgbaImageLanczosDistConvolveJs(t) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.convolve = void 0;
      var e = 14,
        r = function r(a, n, i, s, u, l) {
          var o = 0,
            c = 0;
          for (var f = 0; f < s; f++) {
            var h = 0;
            for (var p = 0; p < u; p++) {
              var m = l[h++],
                d = o + m * 4 | 0,
                y = 0,
                v = 0,
                A = 0,
                g = 0;
              for (var M = l[h++]; M > 0; M--) {
                var S = l[h++];
                y = y + S * a[d] | 0, v = v + S * a[d + 1] | 0, A = A + S * a[d + 2] | 0, g = g + S * a[d + 3] | 0, d = d + 4 | 0;
              }
              n[c] = y + 8192 >> e, n[c + 1] = v + 8192 >> e, n[c + 2] = A + 8192 >> e, n[c + 3] = g + 8192 >> e, c = c + s * 4 | 0;
            }
            c = (f + 1) * 4 | 0, o = (f + 1) * i * 4 | 0;
          }
        };
      t.convolve = r;
    }
  }),
  Ke = et({
    "../../node_modules/.pnpm/@rgba-image+lanczos@0.1.1/node_modules/@rgba-image/lanczos/dist/index.js": function node_modulesPnpmRgbaImageLanczos011Node_modulesRgbaImageLanczosDistIndexJs(t) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.lanczos2 = t.lanczos = void 0;
      var e = He(),
        r = We(),
        a = Ge(),
        n = Ze(),
        i = function i(l, o) {
          var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
          var f = o.width / l.width,
            h = o.height / l.height,
            p = a.filters(l.width, o.width, f, 0, c),
            m = a.filters(l.height, o.height, h, 0, c),
            d = new Uint8ClampedArray(o.width * l.height * 4);
          n.convolve(l.data, d, l.width, l.height, o.width, p), n.convolve(d, o.data, l.height, o.width, o.height, m);
        },
        s = function s(l, o) {
          var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
          var f = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
          var h = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : l.width - c;
          var p = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : l.height - f;
          var m = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
          var d = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
          var y = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : o.width - m;
          var v = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : o.height - d;
          if (c = c | 0, f = f | 0, h = h | 0, p = p | 0, m = m | 0, d = d | 0, y = y | 0, v = v | 0, h <= 0 || p <= 0 || y <= 0 || v <= 0) return;
          if (c === 0 && f === 0 && h === l.width && p === l.height && m === 0 && d === 0 && y === o.width && v === o.height) {
            i(l, o);
            return;
          }
          var A = r.createImage(h, p),
            g = r.createImage(y, v);
          e.copy(l, A, c, f), i(A, g), e.copy(g, o, 0, 0, g.width, g.height, m, d);
        };
      t.lanczos = s;
      var u = function u(l, o) {
        var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var f = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        var h = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : l.width - c;
        var p = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : l.height - f;
        var m = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
        var d = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
        var y = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : o.width - m;
        var v = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : o.height - d;
        if (c = c | 0, f = f | 0, h = h | 0, p = p | 0, m = m | 0, d = d | 0, y = y | 0, v = v | 0, h <= 0 || p <= 0 || y <= 0 || v <= 0) return;
        if (c === 0 && f === 0 && h === l.width && p === l.height && m === 0 && d === 0 && y === o.width && v === o.height) {
          i(l, o, !0);
          return;
        }
        var A = r.createImage(h, p),
          g = r.createImage(y, v);
        e.copy(l, A, c, f), i(A, g, !0), e.copy(g, o, 0, 0, g.width, g.height, m, d);
      };
      t.lanczos2 = u;
    }
  });
var he = function (t) {
    return t.Bounce = "bounce", t.Normal = "normal", t;
  }(he || {}),
  Ye = ae(he),
  de = z({
    autoplay: w(ct()),
    defaultTheme: w(I()),
    direction: w(ft([Et(1), Et(-1)])),
    hover: w(ct()),
    id: I(),
    intermission: w(j()),
    loop: w(ft([ct(), j()])),
    playMode: w(Ye),
    speed: w(j()),
    themeColor: w(I())
  }),
  Xe = z({
    animations: Y(I()),
    id: I()
  }),
  Qe = z({
    activeAnimationId: w(I()),
    animations: Y(de),
    author: w(I()),
    custom: w(Ot(I(), ne())),
    description: w(I()),
    generator: w(I()),
    keywords: w(I()),
    revision: w(j()),
    themes: w(Y(Xe)),
    states: w(Y(I())),
    version: w(I())
  }),
  tr = ie(de, ["id"]),
  G = z({
    state: I()
  }),
  er = G,
  rr = X([G, z({
    ms: j()
  })]),
  nr = X([G, z({
    count: j()
  })]),
  ar = G,
  ir = G,
  sr = G,
  or = X([G, z({
    threshold: w(Y(j([dt(0), ht(1)])))
  })]),
  ur = z({
    onAfter: w(rr),
    onClick: w(er),
    onComplete: w(sr),
    onEnter: w(nr),
    onMouseEnter: w(ar),
    onMouseLeave: w(ir),
    onShow: w(or)
  }),
  lr = X([tr, z({
    playOnScroll: w(zt([j([dt(0), ht(1)]), j([dt(0), ht(1)])])),
    segments: w(ft([zt([j(), j()]), I()]))
  })]);
X([ur, z({
  animationId: w(I()),
  playbackSettings: lr
})]);
var dr = {
    jpeg: "image/jpeg",
    png: "image/png",
    gif: "image/gif",
    bmp: "image/bmp",
    svg: "image/svg+xml",
    webp: "image/webp",
    mpeg: "audio/mpeg",
    mp3: "audio/mp3"
  },
  oe = {
    jpeg: [255, 216, 255],
    png: [137, 80, 78, 71, 13, 10, 26, 10],
    gif: [71, 73, 70],
    bmp: [66, 77],
    webp: [82, 73, 70, 70, 87, 69, 66, 80],
    svg: [60, 63, 120],
    mp3: [73, 68, 51, 3, 0, 0, 0, 0],
    mpeg: [73, 68, 51, 3, 0, 0, 0, 0]
  };
var pr = function pr(t) {
  var e = null,
    r = [];
  if (!t) return null;
  var a = t.substring(t.indexOf(",") + 1);
  typeof window > "u" ? e = Buffer.from(a, "base64").toString("binary") : e = atob(a);
  var n = new Uint8Array(e.length);
  for (var i = 0; i < e.length; i += 1) n[i] = e.charCodeAt(i);
  r = Array.from(n.subarray(0, 8));
  var _loop2 = function _loop2() {
      var s = oe[_i2];
      if (s && r.every(function (u, l) {
        return u === s[l];
      })) return {
        v: dr[_i2]
      };
    },
    _ret;
  for (var _i2 in oe) {
    _ret = _loop2();
    if (_ret) return _ret.v;
  }
  return null;
};
var Mt = /*#__PURE__*/function (_Error2) {
  function Mt(t, e) {
    var _this2;
    _classCallCheck(this, Mt);
    _this2 = _callSuper(this, Mt, [t]), Je(_assertThisInitialized(_this2), "code"), _this2.name = "[dotlottie-js]", _this2.code = e;
    return _this2;
  }
  _inherits(Mt, _Error2);
  return _createClass(Mt);
}( /*#__PURE__*/_wrapNativeSuper(Error));
function pe(t) {
  var e;
  if (typeof window > "u") e = Buffer.from(t).toString("base64");else {
    var a = Array.prototype.map.call(t, function (n) {
      return String.fromCharCode(n);
    }).join("");
    e = window.btoa(a);
  }
  return "data:".concat(pr(e), ";base64,").concat(e);
}
function ue(t) {
  return "w" in t && "h" in t && !("xt" in t) && "p" in t;
}
function pt(t) {
  return !("h" in t) && !("w" in t) && "p" in t && "e" in t && "u" in t && "id" in t;
}
function rt(_x) {
  return _rt.apply(this, arguments);
}
function _rt() {
  _rt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t) {
    var e,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          e = _args.length > 1 && _args[1] !== undefined ? _args[1] : function () {
            return !0;
          };
          if (t instanceof Uint8Array) {
            _context.next = 3;
            break;
          }
          throw new Mt("DotLottie not found", "INVALID_DOTLOTTIE");
        case 3:
          _context.next = 5;
          return new Promise(function (a, n) {
            ee(t, {
              filter: e
            }, function (i, s) {
              i && n(i), a(s);
            });
          });
        case 5:
          return _context.abrupt("return", _context.sent);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _rt.apply(this, arguments);
}
function Dt(_x2, _x3, _x4) {
  return _Dt.apply(this, arguments);
}
function _Dt() {
  _Dt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(t, e, r) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (t instanceof Uint8Array) {
            _context2.next = 2;
            break;
          }
          throw new Mt("DotLottie not found", "INVALID_DOTLOTTIE");
        case 2:
          _context2.next = 4;
          return rt(t, function (n) {
            return n.name === e && (!r || r(n));
          });
        case 4:
          _context2.t0 = e;
          return _context2.abrupt("return", _context2.sent[_context2.t0]);
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _Dt.apply(this, arguments);
}
function mr(_x5) {
  return _mr.apply(this, arguments);
}
function _mr() {
  _mr = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(t) {
    var e, a;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          e = "manifest.json";
          _context3.next = 3;
          return rt(t, function (n) {
            return n.name === e;
          });
        case 3:
          _context3.t0 = e;
          a = _context3.sent[_context3.t0];
          if (typeof a > "u") {
            _context3.next = 7;
            break;
          }
          return _context3.abrupt("return", JSON.parse(W(a, !1)));
        case 7:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _mr.apply(this, arguments);
}
function vr(_x6) {
  return _vr.apply(this, arguments);
}
function _vr() {
  _vr = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(t) {
    var e, r;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (t instanceof Uint8Array) {
            _context4.next = 2;
            break;
          }
          return _context4.abrupt("return", {
            success: !1,
            error: "DotLottie not found"
          });
        case 2:
          _context4.next = 4;
          return mr(t);
        case 4:
          e = _context4.sent;
          if (!(typeof e > "u")) {
            _context4.next = 7;
            break;
          }
          return _context4.abrupt("return", {
            success: !1,
            error: "Invalid .lottie file, manifest.json is missing"
          });
        case 7:
          r = se(Qe, e);
          return _context4.abrupt("return", r.success ? {
            success: !0
          } : {
            success: !1,
            error: "Invalid .lottie file, manifest.json structure is invalid, ".concat(JSON.stringify(re(r.error).nested, null, 2))
          });
        case 9:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _vr.apply(this, arguments);
}
function Yr(_x7) {
  return _Yr.apply(this, arguments);
}
function _Yr() {
  _Yr = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(t) {
    var e, r;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          e = new Uint8Array(t);
          _context5.next = 3;
          return vr(e);
        case 3:
          r = _context5.sent;
          if (!r.error) {
            _context5.next = 6;
            break;
          }
          throw new Mt(r.error, "INVALID_DOTLOTTIE");
        case 6:
          return _context5.abrupt("return", e);
        case 7:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _Yr.apply(this, arguments);
}
function yr(_x8, _x9) {
  return _yr.apply(this, arguments);
}
function _yr() {
  _yr = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(t, e) {
    var r, a, n, i, s;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return rt(t, function (n) {
            var i = n.name.replace("audio/", "");
            return n.name.startsWith("audio/") && (!e || e(_objectSpread(_objectSpread({}, n), {}, {
              name: i
            })));
          });
        case 2:
          r = _context6.sent;
          a = {};
          for (n in r) {
            i = r[n];
            if (i instanceof Uint8Array) {
              s = n.replace("audio/", "");
              a[s] = pe(i);
            }
          }
          return _context6.abrupt("return", a);
        case 6:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _yr.apply(this, arguments);
}
function gr(_x10, _x11) {
  return _gr.apply(this, arguments);
}
function _gr() {
  _gr = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(t, e) {
    var n, r, _i3, _Object$entries2, _Object$entries2$_i, i, s, _iterator12, _step12, u, l, a, _iterator13, _step13, _step13$value, _i4, _s, _u, _iterator14, _step14, _l, o, _iterator15, _step15, c;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          r = new Map();
          for (_i3 = 0, _Object$entries2 = Object.entries(e); _i3 < _Object$entries2.length; _i3++) {
            _Object$entries2$_i = _slicedToArray(_Object$entries2[_i3], 2), i = _Object$entries2$_i[0], s = _Object$entries2$_i[1];
            _iterator12 = _createForOfIteratorHelper(s.assets || []);
            try {
              for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                u = _step12.value;
                if (pt(u)) {
                  l = u.p;
                  r.has(l) || r.set(l, new Set()), (n = r.get(l)) == null || n.add(i);
                }
              }
            } catch (err) {
              _iterator12.e(err);
            } finally {
              _iterator12.f();
            }
          }
          _context7.next = 4;
          return yr(t, function (i) {
            return r.has(i.name);
          });
        case 4:
          a = _context7.sent;
          _iterator13 = _createForOfIteratorHelper(r);
          try {
            for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
              _step13$value = _slicedToArray(_step13.value, 2), _i4 = _step13$value[0], _s = _step13$value[1];
              _u = a[_i4];
              if (_u) {
                _iterator14 = _createForOfIteratorHelper(_s);
                try {
                  for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                    _l = _step14.value;
                    o = e[_l];
                    _iterator15 = _createForOfIteratorHelper((o == null ? void 0 : o.assets) || []);
                    try {
                      for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
                        c = _step15.value;
                        pt(c) && c.p === _i4 && (c.p = _u, c.u = "", c.e = 1);
                      }
                    } catch (err) {
                      _iterator15.e(err);
                    } finally {
                      _iterator15.f();
                    }
                  }
                } catch (err) {
                  _iterator14.e(err);
                } finally {
                  _iterator14.f();
                }
              }
            }
          } catch (err) {
            _iterator13.e(err);
          } finally {
            _iterator13.f();
          }
        case 7:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _gr.apply(this, arguments);
}
function _r(_x12, _x13) {
  return _r2.apply(this, arguments);
}
function _r2() {
  _r2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(t, e) {
    var r, a, n, i, s;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return rt(t, function (n) {
            var i = n.name.replace("images/", "");
            return n.name.startsWith("images/") && (!e || e(_objectSpread(_objectSpread({}, n), {}, {
              name: i
            })));
          });
        case 2:
          r = _context8.sent;
          a = {};
          for (n in r) {
            i = r[n];
            if (i instanceof Uint8Array) {
              s = n.replace("images/", "");
              a[s] = pe(i);
            }
          }
          return _context8.abrupt("return", a);
        case 6:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _r2.apply(this, arguments);
}
function wr(_x14, _x15) {
  return _wr.apply(this, arguments);
}
function _wr() {
  _wr = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(t, e) {
    var n, r, _i5, _Object$entries3, _Object$entries3$_i, i, s, _iterator16, _step16, u, l, a, _iterator17, _step17, _step17$value, _i6, _s2, _u2, _iterator18, _step18, _l2, o, _iterator19, _step19, c;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          r = new Map();
          for (_i5 = 0, _Object$entries3 = Object.entries(e); _i5 < _Object$entries3.length; _i5++) {
            _Object$entries3$_i = _slicedToArray(_Object$entries3[_i5], 2), i = _Object$entries3$_i[0], s = _Object$entries3$_i[1];
            _iterator16 = _createForOfIteratorHelper(s.assets || []);
            try {
              for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
                u = _step16.value;
                if (ue(u)) {
                  l = u.p;
                  r.has(l) || r.set(l, new Set()), (n = r.get(l)) == null || n.add(i);
                }
              }
            } catch (err) {
              _iterator16.e(err);
            } finally {
              _iterator16.f();
            }
          }
          _context9.next = 4;
          return _r(t, function (i) {
            return r.has(i.name);
          });
        case 4:
          a = _context9.sent;
          _iterator17 = _createForOfIteratorHelper(r);
          try {
            for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
              _step17$value = _slicedToArray(_step17.value, 2), _i6 = _step17$value[0], _s2 = _step17$value[1];
              _u2 = a[_i6];
              if (_u2) {
                _iterator18 = _createForOfIteratorHelper(_s2);
                try {
                  for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
                    _l2 = _step18.value;
                    o = e[_l2];
                    _iterator19 = _createForOfIteratorHelper((o == null ? void 0 : o.assets) || []);
                    try {
                      for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
                        c = _step19.value;
                        ue(c) && c.p === _i6 && (c.p = _u2, c.u = "", c.e = 1);
                      }
                    } catch (err) {
                      _iterator19.e(err);
                    } finally {
                      _iterator19.f();
                    }
                  }
                } catch (err) {
                  _iterator18.e(err);
                } finally {
                  _iterator18.f();
                }
              }
            }
          } catch (err) {
            _iterator17.e(err);
          } finally {
            _iterator17.f();
          }
        case 7:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _wr.apply(this, arguments);
}
function Xr(_x16, _x17) {
  return _Xr.apply(this, arguments);
}
function _Xr() {
  _Xr = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(t, e) {
    var _ref4,
      r,
      a,
      n,
      i,
      s,
      u,
      _args10 = arguments;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _ref4 = _args10.length > 2 && _args10[2] !== undefined ? _args10[2] : {}, r = _ref4.inlineAssets;
          a = _args10.length > 3 ? _args10[3] : undefined;
          n = "animations/".concat(e, ".json");
          _context10.next = 5;
          return Dt(t, n, a);
        case 5:
          i = _context10.sent;
          if (!(typeof i > "u")) {
            _context10.next = 8;
            break;
          }
          return _context10.abrupt("return");
        case 8:
          s = JSON.parse(W(i, !1));
          if (r) {
            _context10.next = 11;
            break;
          }
          return _context10.abrupt("return", s);
        case 11:
          u = _defineProperty({}, e, s);
          _context10.next = 14;
          return wr(t, u);
        case 14:
          _context10.next = 16;
          return gr(t, u);
        case 16:
          return _context10.abrupt("return", s);
        case 17:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return _Xr.apply(this, arguments);
}
function Qr(_x18, _x19, _x20) {
  return _Qr.apply(this, arguments);
}
function _Qr() {
  _Qr = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(t, e, r) {
    var a, n;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          a = "themes/".concat(e, ".json");
          _context11.next = 3;
          return Dt(t, a, r);
        case 3:
          n = _context11.sent;
          if (typeof n > "u") {
            _context11.next = 6;
            break;
          }
          return _context11.abrupt("return", JSON.parse(W(n, !1)));
        case 6:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return _Qr.apply(this, arguments);
}
function tn(_x21, _x22) {
  return _tn.apply(this, arguments);
}
function _tn() {
  _tn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(t, e) {
    var r, a, n, i, s;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          r = {};
          _context12.next = 3;
          return rt(t, function (n) {
            var i = n.name.replace("states/", "").replace(".json", "");
            return n.name.startsWith("states/") && (!e || e(_objectSpread(_objectSpread({}, n), {}, {
              name: i
            })));
          });
        case 3:
          a = _context12.sent;
          for (n in a) {
            i = a[n];
            if (i instanceof Uint8Array) {
              s = n.replace("states/", "").replace(".json", "");
              r[s] = W(i, !1);
            }
          }
          return _context12.abrupt("return", r);
        case 6:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return _tn.apply(this, arguments);
}
function en(_x23, _x24, _x25) {
  return _en.apply(this, arguments);
}
function _en() {
  _en = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(t, e, r) {
    var a, n;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          a = "states/".concat(e, ".json");
          _context13.next = 3;
          return Dt(t, a, r);
        case 3:
          n = _context13.sent;
          return _context13.abrupt("return", typeof n > "u" ? void 0 : JSON.parse(W(n, !1)));
        case 5:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return _en.apply(this, arguments);
}
$e(Ke());
function on(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "dotLottie-common";
  return new Error("[".concat(e, "]: ").concat(t));
}
function un(t) {
  var _console;
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "dotLottie-common";
  for (var _len = arguments.length, r = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    r[_key - 2] = arguments[_key];
  }
  (_console = console).error.apply(_console, ["[".concat(e, "]:"), t].concat(r));
}
function ln(t) {
  var _console2;
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "dotLottie-common";
  for (var _len2 = arguments.length, r = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    r[_key2 - 2] = arguments[_key2];
  }
  (_console2 = console).warn.apply(_console2, ["[".concat(e, "]:"), t].concat(r));
}
function cn() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var e = t.trim(),
    r = e.lastIndexOf("/"),
    a = e.substring(r + 1),
    n = a.indexOf(".");
  return n !== -1 ? a.substring(0, n) : a;
}
function kr(t) {
  return ["v", "ip", "op", "layers", "fr", "w", "h"].every(function (r) {
    return Object.prototype.hasOwnProperty.call(t, r);
  });
}
function fn(t) {
  var e = t.assets;
  return e ? e.some(function (r) {
    return pt(r);
  }) : !1;
}
function hn(t) {
  try {
    var e = JSON.parse(t);
    return kr(e);
  } catch (_unused2) {
    return !1;
  }
}
function dn(t, e) {
  var r = Object.keys(t).find(function (a) {
    return t[a] === e;
  });
  if (r === void 0) throw new Error("Value not found in the object.");
  return r;
}
function pn(t) {
  return JSON.parse(JSON.stringify(t));
}
export { tr as a, mr as b, Yr as c, Xr as d, Qr as e, tn as f, en as g, on as h, un as i, ln as j, cn as k, kr as l, fn as m, hn as n, dn as o, pn as p };